function PlanS({ ...props }) {
	return (
		<g id="plan-s">
			<g id="furniture">
				<polyline
					points="320.87 787.41 318.35 787.41 318.35 782.43 320.87 782.43 320.87 787.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="196.02"
					y1="431.24"
					x2="268.58"
					y2="431.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.02"
					y1="544.89"
					x2="196.02"
					y2="431.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.94"
					y1="393.44"
					x2="224.89"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.26"
					y1="393.44"
					x2="215.21"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.58"
					y1="393.44"
					x2="205.53"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.91"
					y1="393.44"
					x2="195.86"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.23"
					y1="393.44"
					x2="186.18"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.55"
					y1="393.44"
					x2="176.5"
					y2="393.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="422.6"
					x2="158.22"
					y2="428.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="432.27"
					x2="158.22"
					y2="438.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="441.95"
					x2="158.22"
					y2="448"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="451.63"
					x2="158.22"
					y2="457.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="461.3"
					x2="158.22"
					y2="467.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="470.98"
					x2="158.22"
					y2="477.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="480.66"
					x2="158.22"
					y2="486.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="490.33"
					x2="158.22"
					y2="496.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="500.01"
					x2="158.22"
					y2="506.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.22"
					y1="509.69"
					x2="158.22"
					y2="515.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="544.89"
					x2="193.5"
					y2="541.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="538.21"
					x2="193.5"
					y2="532.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="528.54"
					x2="193.5"
					y2="522.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="518.86"
					x2="193.5"
					y2="512.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="509.18"
					x2="193.5"
					y2="503.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="499.51"
					x2="193.5"
					y2="493.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="489.83"
					x2="193.5"
					y2="483.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="480.15"
					x2="193.5"
					y2="474.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="470.48"
					x2="193.5"
					y2="464.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="460.8"
					x2="193.5"
					y2="454.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="451.12"
					x2="193.5"
					y2="445.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="441.45"
					x2="193.5"
					y2="435.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="431.77"
					x2="193.5"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.5"
					y1="428.72"
					x2="195.37"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.98"
					y1="428.72"
					x2="205.03"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.66"
					y1="428.72"
					x2="214.71"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.34"
					y1="428.72"
					x2="224.38"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.01"
					y1="428.72"
					x2="234.06"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.69"
					y1="428.72"
					x2="243.74"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.37"
					y1="428.72"
					x2="253.42"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.04"
					y1="428.72"
					x2="263.09"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.7"
					y1="428.72"
					x2="268.58"
					y2="428.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="428.72"
					x2="268.58"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="731.87 903.85 731.87 835.8 799.91 835.8 799.91 903.85 731.87 903.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="664.09 54.05 624.53 54.05 624.53 59.5 664.09 59.5 664.09 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="622.55 53.55 666.07 53.55 666.07 54.05 622.55 54.05 622.55 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="622.55"
					y1="53.55"
					x2="666.07"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.07"
					y1="53.55"
					x2="666.07"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.07"
					y1="54.05"
					x2="622.55"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.55"
					y1="54.05"
					x2="622.55"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.09"
					y1="59.5"
					x2="624.53"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.53"
					y1="54.05"
					x2="664.09"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="668.55 59.5 664.09 59.5 664.09 54.05 668.55 54.05 668.55 59.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="668.55"
					y1="59.5"
					x2="664.09"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.09"
					y1="59.5"
					x2="664.09"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.09"
					y1="54.05"
					x2="668.55"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.55"
					y1="54.05"
					x2="668.55"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="620.06 54.05 624.53 54.05 624.53 59.5 620.06 59.5 620.06 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="620.06"
					y1="54.05"
					x2="624.53"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.53"
					y1="54.05"
					x2="624.53"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.53"
					y1="59.5"
					x2="620.06"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.06"
					y1="59.5"
					x2="620.06"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.09"
					y1="55.04"
					x2="624.53"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="670.54 59.01 668.55 59.01 668.55 54.05 666.07 54.05 666.07 53.55 670.54 53.55 670.54 59.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="670.54"
					y1="59.01"
					x2="668.55"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.55"
					y1="59.01"
					x2="668.55"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.55"
					y1="54.05"
					x2="666.07"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.07"
					y1="54.05"
					x2="666.07"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.07"
					y1="53.55"
					x2="670.54"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.54"
					y1="53.55"
					x2="670.54"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="618.08 53.55 622.55 53.55 622.55 54.05 620.06 54.05 620.06 59.01 618.08 59.01 618.08 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.08"
					y1="53.55"
					x2="622.55"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.55"
					y1="53.55"
					x2="622.55"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.55"
					y1="54.05"
					x2="620.06"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.06"
					y1="54.05"
					x2="620.06"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.06"
					y1="59.01"
					x2="618.08"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.08"
					y1="59.01"
					x2="618.08"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="615.56 55.04 615.56 57.56 510.57 57.56 510.57 55.04 615.56 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="615.56"
					y1="55.04"
					x2="615.56"
					y2="57.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.56"
					y1="57.56"
					x2="510.57"
					y2="57.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.57"
					y1="57.56"
					x2="510.57"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.57"
					y1="55.04"
					x2="615.56"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="670.54 55.04 675.58 55.04 675.58 70.16 670.54 70.16 670.54 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="675.58"
					y1="55.04"
					x2="670.54"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.58"
					y1="70.16"
					x2="675.58"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.54"
					y1="70.16"
					x2="675.58"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.54"
					y1="55.04"
					x2="670.54"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="613.04 55.04 618.08 55.04 618.08 70.16 613.04 70.16 613.04 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.08"
					y1="55.04"
					x2="613.04"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.08"
					y1="70.16"
					x2="618.08"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.04"
					y1="70.16"
					x2="618.08"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.04"
					y1="55.04"
					x2="613.04"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="508.05 55.04 513.09 55.04 513.09 70.16 508.05 70.16 508.05 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="513.09"
					y1="55.04"
					x2="508.05"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.09"
					y1="70.16"
					x2="513.09"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.05"
					y1="70.16"
					x2="513.09"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.05"
					y1="55.04"
					x2="508.05"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="357.25 54.05 317.7 54.05 317.7 59.5 357.25 59.5 357.25 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="315.71 53.55 359.24 53.55 359.24 54.05 315.71 54.05 315.71 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="315.71"
					y1="53.55"
					x2="359.24"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.24"
					y1="53.55"
					x2="359.24"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.24"
					y1="54.05"
					x2="315.71"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.71"
					y1="54.05"
					x2="315.71"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.25"
					y1="59.5"
					x2="317.7"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.7"
					y1="54.05"
					x2="357.25"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="361.72 59.5 357.25 59.5 357.25 54.05 361.72 54.05 361.72 59.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="361.72"
					y1="59.5"
					x2="357.25"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.25"
					y1="59.5"
					x2="357.25"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.25"
					y1="54.05"
					x2="361.72"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.72"
					y1="54.05"
					x2="361.72"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="313.23 54.05 317.7 54.05 317.7 59.5 313.23 59.5 313.23 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="313.23"
					y1="54.05"
					x2="317.7"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.7"
					y1="54.05"
					x2="317.7"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.7"
					y1="59.5"
					x2="313.23"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.23"
					y1="59.5"
					x2="313.23"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.25"
					y1="55.04"
					x2="317.7"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="363.71 59.01 361.72 59.01 361.72 54.05 359.24 54.05 359.24 53.55 363.71 53.55 363.71 59.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="363.71"
					y1="59.01"
					x2="361.72"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.72"
					y1="59.01"
					x2="361.72"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.72"
					y1="54.05"
					x2="359.24"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.24"
					y1="54.05"
					x2="359.24"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.24"
					y1="53.55"
					x2="363.71"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.71"
					y1="53.55"
					x2="363.71"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="311.25 53.55 315.71 53.55 315.71 54.05 313.23 54.05 313.23 59.01 311.25 59.01 311.25 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="311.25"
					y1="53.55"
					x2="315.71"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.71"
					y1="53.55"
					x2="315.71"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.71"
					y1="54.05"
					x2="313.23"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.23"
					y1="54.05"
					x2="313.23"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.23"
					y1="59.01"
					x2="311.25"
					y2="59.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.25"
					y1="59.01"
					x2="311.25"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="308.73 55.04 308.73 57.56 203.74 57.56 203.74 55.04 308.73 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="308.73"
					y1="55.04"
					x2="308.73"
					y2="57.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.73"
					y1="57.56"
					x2="203.74"
					y2="57.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.74"
					y1="57.56"
					x2="203.74"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.74"
					y1="55.04"
					x2="308.73"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="363.71 55.04 368.75 55.04 368.75 70.16 363.71 70.16 363.71 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="368.75"
					y1="55.04"
					x2="363.71"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.75"
					y1="70.16"
					x2="368.75"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.71"
					y1="70.16"
					x2="368.75"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.71"
					y1="55.04"
					x2="363.71"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="306.21 55.04 311.25 55.04 311.25 70.16 306.21 70.16 306.21 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="311.25"
					y1="55.04"
					x2="306.21"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.25"
					y1="70.16"
					x2="311.25"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.21"
					y1="70.16"
					x2="311.25"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.21"
					y1="55.04"
					x2="306.21"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="201.22 55.04 206.26 55.04 206.26 70.16 201.22 70.16 201.22 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="206.26"
					y1="55.04"
					x2="201.22"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.26"
					y1="70.16"
					x2="206.26"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.22"
					y1="70.16"
					x2="206.26"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.22"
					y1="55.04"
					x2="201.22"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.35"
					y1="948.74"
					x2="705.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="705.13"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="701.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="948.74"
					x2="601.81"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="601.81"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="605.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="606.85 950 606.85 948.74 601.81 948.74 601.81 950 606.85 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="700.09 948.74 700.09 950 705.13 950 705.13 948.74 700.09 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="606.85 928.58 606.85 927.32 601.81 927.32 601.81 928.58 606.85 928.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="700.09 927.32 700.09 928.58 705.13 928.58 705.13 927.32 700.09 927.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="606.85"
					y1="950"
					x2="601.81"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.81"
					y1="950"
					x2="601.81"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.81"
					y1="948.74"
					x2="606.85"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.85"
					y1="948.74"
					x2="606.85"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.09"
					y1="948.74"
					x2="705.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.13"
					y1="948.74"
					x2="705.13"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.13"
					y1="950"
					x2="700.09"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.09"
					y1="950"
					x2="700.09"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.85"
					y1="928.58"
					x2="601.81"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.81"
					y1="928.58"
					x2="601.81"
					y2="927.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.81"
					y1="927.32"
					x2="606.85"
					y2="927.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.85"
					y1="927.32"
					x2="606.85"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.09"
					y1="927.32"
					x2="705.13"
					y2="927.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.13"
					y1="927.32"
					x2="705.13"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.13"
					y1="928.58"
					x2="700.09"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.09"
					y1="928.58"
					x2="700.09"
					y2="927.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="608.11 948.74 608.11 928.58 606.22 928.58 606.22 948.74 608.11 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="700.72 948.74 700.72 928.58 698.83 928.58 698.83 948.74 700.72 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="634.68 864.43 631.57 867.55 695.71 931.7 698.83 928.58 634.68 864.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="606.22"
					y1="928.58"
					x2="605.59"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.22"
					y1="948.74"
					x2="605.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="605.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.72"
					y1="928.58"
					x2="701.35"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.72"
					y1="948.74"
					x2="701.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="701.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.11"
					y1="948.74"
					x2="608.11"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.11"
					y1="928.58"
					x2="606.22"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.22"
					y1="928.58"
					x2="606.22"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.22"
					y1="948.74"
					x2="608.11"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.72"
					y1="948.74"
					x2="700.72"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.72"
					y1="928.58"
					x2="698.83"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.83"
					y1="928.58"
					x2="698.83"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.83"
					y1="948.74"
					x2="700.72"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.68"
					y1="864.43"
					x2="631.57"
					y2="867.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="867.55"
					x2="695.71"
					y2="931.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.71"
					y1="931.7"
					x2="698.83"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.83"
					y1="928.58"
					x2="634.68"
					y2="864.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="605.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="605.59"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="601.81"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="928.58"
					x2="601.81"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="948.74"
					x2="601.81"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.59"
					y1="948.74"
					x2="601.81"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="701.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="701.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="705.13"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="928.58"
					x2="705.13"
					y2="928.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="948.74"
					x2="705.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="701.35"
					y1="948.74"
					x2="705.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="201.22"
					y1="50"
					x2="201.22"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="557.49"
					x2="427.92"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="427.92"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="424.14"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="557.49"
					x2="339.72"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="339.72"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="205.61"
					y1="557.49"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="281.18"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="344.76 558.75 344.76 557.49 339.72 557.49 339.72 558.75 344.76 558.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="422.88 557.49 422.88 558.75 427.92 558.75 427.92 557.49 422.88 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="344.76 544.89 344.76 543.63 339.72 543.63 339.72 544.89 344.76 544.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="422.88 543.63 422.88 544.89 427.92 544.89 427.92 543.63 422.88 543.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="344.76"
					y1="558.75"
					x2="339.72"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.72"
					y1="558.75"
					x2="339.72"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.72"
					y1="557.49"
					x2="344.76"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.76"
					y1="557.49"
					x2="344.76"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.88"
					y1="557.49"
					x2="427.92"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.92"
					y1="557.49"
					x2="427.92"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.92"
					y1="558.75"
					x2="422.88"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.88"
					y1="558.75"
					x2="422.88"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.76"
					y1="544.89"
					x2="339.72"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.72"
					y1="544.89"
					x2="339.72"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.72"
					y1="543.63"
					x2="344.76"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.76"
					y1="543.63"
					x2="344.76"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.88"
					y1="543.63"
					x2="427.92"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.92"
					y1="543.63"
					x2="427.92"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.92"
					y1="544.89"
					x2="422.88"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.88"
					y1="544.89"
					x2="422.88"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="346.02 557.49 346.02 544.89 344.13 544.89 344.13 557.49 346.02 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="423.51 557.49 423.51 544.89 421.62 544.89 421.62 557.49 423.51 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="368.16 491.43 365.04 494.55 418.5 548.01 421.62 544.89 368.16 491.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="344.13"
					y1="544.89"
					x2="343.5"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.13"
					y1="557.49"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.51"
					y1="544.89"
					x2="424.14"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.51"
					y1="557.49"
					x2="424.14"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="424.14"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.02"
					y1="557.49"
					x2="346.02"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.02"
					y1="544.89"
					x2="344.13"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.13"
					y1="544.89"
					x2="344.13"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.13"
					y1="557.49"
					x2="346.02"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.51"
					y1="557.49"
					x2="423.51"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.51"
					y1="544.89"
					x2="421.62"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.62"
					y1="544.89"
					x2="421.62"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.62"
					y1="557.49"
					x2="423.51"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.16"
					y1="491.43"
					x2="365.04"
					y2="494.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.04"
					y1="494.55"
					x2="418.5"
					y2="548.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.5"
					y1="548.01"
					x2="421.62"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.62"
					y1="544.89"
					x2="368.16"
					y2="491.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="343.5"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="339.72"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="544.89"
					x2="339.72"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="557.49"
					x2="339.72"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="343.5"
					y1="557.49"
					x2="339.72"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="424.14"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="424.14"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="427.92"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="544.89"
					x2="427.92"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="557.49"
					x2="427.92"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="424.14"
					y1="557.49"
					x2="427.92"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="557.49"
					x2="454"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="454"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="557.49"
					x2="542.2"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="542.2"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="538.42"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="451"
					y1="557.49"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="557.49"
					x2="544.55"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="451"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="537.16 558.75 542.2 558.75 542.2 557.49 537.16 557.49 537.16 558.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.04 557.49 454 557.49 454 558.75 459.04 558.75 459.04 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="537.16 544.89 542.2 544.89 542.2 543.63 537.16 543.63 537.16 544.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.04 543.63 454 543.63 454 544.89 459.04 544.89 459.04 543.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.16"
					y1="558.75"
					x2="542.2"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.2"
					y1="558.75"
					x2="542.2"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.2"
					y1="557.49"
					x2="537.16"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.16"
					y1="557.49"
					x2="537.16"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.04"
					y1="557.49"
					x2="454"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454"
					y1="557.49"
					x2="454"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454"
					y1="558.75"
					x2="459.04"
					y2="558.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.04"
					y1="558.75"
					x2="459.04"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.16"
					y1="544.89"
					x2="542.2"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.2"
					y1="544.89"
					x2="542.2"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.2"
					y1="543.63"
					x2="537.16"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.16"
					y1="543.63"
					x2="537.16"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.04"
					y1="543.63"
					x2="454"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454"
					y1="543.63"
					x2="454"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454"
					y1="544.89"
					x2="459.04"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.04"
					y1="544.89"
					x2="459.04"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="535.9 557.49 537.79 557.49 537.79 544.89 535.9 544.89 535.9 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="458.41 557.49 460.3 557.49 460.3 544.89 458.41 544.89 458.41 557.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="513.76 491.43 460.3 544.89 463.42 548.01 516.88 494.55 513.76 491.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.79"
					y1="544.89"
					x2="538.42"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.79"
					y1="557.49"
					x2="538.42"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="538.42"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.41"
					y1="544.89"
					x2="457.78"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.41"
					y1="557.49"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.9"
					y1="557.49"
					x2="535.9"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.9"
					y1="544.89"
					x2="537.79"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.79"
					y1="544.89"
					x2="537.79"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.79"
					y1="557.49"
					x2="535.9"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.41"
					y1="557.49"
					x2="458.41"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.41"
					y1="544.89"
					x2="460.3"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.3"
					y1="544.89"
					x2="460.3"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.3"
					y1="557.49"
					x2="458.41"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.76"
					y1="491.43"
					x2="516.88"
					y2="494.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.88"
					y1="494.55"
					x2="463.42"
					y2="548.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.42"
					y1="548.01"
					x2="460.3"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.3"
					y1="544.89"
					x2="513.76"
					y2="491.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="538.42"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="538.42"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="542.2"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="544.89"
					x2="542.2"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="557.49"
					x2="542.2"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="538.42"
					y1="557.49"
					x2="542.2"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="457.78"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="454"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="544.89"
					x2="454"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="557.49"
					x2="454"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="457.78"
					y1="557.49"
					x2="454"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="905.33"
					x2="724.41"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="711.81"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="724.41"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="834.77"
					x2="724.41"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="711.81"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="724.41"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="711.73"
					x2="711.81"
					y2="791.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="725.67 836.03 725.67 830.99 724.41 830.99 724.41 836.03 725.67 836.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="724.41 904.07 724.41 909.11 725.67 909.11 725.67 904.07 724.41 904.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="711.81 836.03 711.81 830.99 710.55 830.99 710.55 836.03 711.81 836.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="710.55 904.07 710.55 909.11 711.81 909.11 711.81 904.07 710.55 904.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="725.67"
					y1="836.03"
					x2="725.67"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.67"
					y1="830.99"
					x2="724.41"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="830.99"
					x2="724.41"
					y2="836.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="836.03"
					x2="725.67"
					y2="836.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="904.07"
					x2="724.41"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="909.11"
					x2="725.67"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.67"
					y1="909.11"
					x2="725.67"
					y2="904.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.67"
					y1="904.07"
					x2="724.41"
					y2="904.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="836.03"
					x2="711.81"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="830.99"
					x2="710.55"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="830.99"
					x2="710.55"
					y2="836.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="836.03"
					x2="711.81"
					y2="836.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="904.07"
					x2="710.55"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="909.11"
					x2="711.81"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="909.11"
					x2="711.81"
					y2="904.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="904.07"
					x2="710.55"
					y2="904.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="724.41 837.29 724.41 835.4 711.81 835.4 711.81 837.29 724.41 837.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="724.41 904.7 724.41 902.81 711.81 902.81 711.81 904.7 724.41 904.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="665.48 856.48 711.81 902.81 714.93 899.69 668.6 853.36 665.48 856.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.81"
					y1="835.4"
					x2="711.81"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="835.4"
					x2="724.41"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="724.41"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="904.7"
					x2="711.81"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="904.7"
					x2="724.41"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="724.41"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="837.29"
					x2="711.81"
					y2="837.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="837.29"
					x2="711.81"
					y2="835.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="835.4"
					x2="724.41"
					y2="835.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="835.4"
					x2="724.41"
					y2="837.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="904.7"
					x2="711.81"
					y2="904.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="904.7"
					x2="711.81"
					y2="902.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="902.81"
					x2="724.41"
					y2="902.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.41"
					y1="902.81"
					x2="724.41"
					y2="904.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.48"
					y1="856.48"
					x2="668.6"
					y2="853.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.6"
					y1="853.36"
					x2="714.93"
					y2="899.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.93"
					y1="899.69"
					x2="711.81"
					y2="902.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="902.81"
					x2="665.48"
					y2="856.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="724.41"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="724.41"
					y2="834.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="711.81"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="834.77"
					x2="711.81"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="834.77"
					x2="724.41"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="834.77"
					x2="724.41"
					y2="830.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="724.41"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="724.41"
					y2="905.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="711.81"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="905.33"
					x2="711.81"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="905.33"
					x2="724.41"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="724.41"
					y1="905.33"
					x2="724.41"
					y2="909.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="711.73"
					x2="724.41"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="727.04"
					y1="711.73"
					x2="724.41"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="711.81"
					y1="791.92"
					x2="557.15"
					y2="791.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="571.12"
					x2="544.55"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="557.15"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="651.76"
					x2="544.55"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="557.15"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="544.55"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="791.92"
					x2="557.15"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="557.49"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="651.76"
					x2="544.55"
					y2="791.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="543.29 650.5 543.29 655.54 544.55 655.54 544.55 650.5 543.29 650.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="544.55 572.37 544.55 567.33 543.29 567.33 543.29 572.37 544.55 572.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="557.15 650.5 557.15 655.54 558.41 655.54 558.41 650.5 557.15 650.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="558.41 572.37 558.41 567.33 557.15 567.33 557.15 572.37 558.41 572.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="543.29"
					y1="650.5"
					x2="543.29"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.29"
					y1="655.54"
					x2="544.55"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="655.54"
					x2="544.55"
					y2="650.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="650.5"
					x2="543.29"
					y2="650.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="572.37"
					x2="544.55"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="567.33"
					x2="543.29"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.29"
					y1="567.33"
					x2="543.29"
					y2="572.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.29"
					y1="572.37"
					x2="544.55"
					y2="572.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="650.5"
					x2="557.15"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="655.54"
					x2="558.41"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.41"
					y1="655.54"
					x2="558.41"
					y2="650.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.41"
					y1="650.5"
					x2="557.15"
					y2="650.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.41"
					y1="572.37"
					x2="558.41"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.41"
					y1="567.33"
					x2="557.15"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="567.33"
					x2="557.15"
					y2="572.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="572.37"
					x2="558.41"
					y2="572.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="544.55 649.24 544.55 651.13 557.15 651.13 557.15 649.24 544.55 649.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="544.55 571.75 544.55 573.64 557.15 573.64 557.15 571.75 544.55 571.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="610.61 627.09 557.15 573.64 554.04 576.76 607.49 630.21 610.61 627.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="557.15"
					y1="651.13"
					x2="557.15"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="651.13"
					x2="544.55"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="544.55"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="571.75"
					x2="557.15"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="571.75"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="649.24"
					x2="557.15"
					y2="649.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="649.24"
					x2="557.15"
					y2="651.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="651.13"
					x2="544.55"
					y2="651.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="651.13"
					x2="544.55"
					y2="649.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="571.75"
					x2="557.15"
					y2="571.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="571.75"
					x2="557.15"
					y2="573.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="573.64"
					x2="544.55"
					y2="573.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.55"
					y1="573.64"
					x2="544.55"
					y2="571.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.61"
					y1="627.09"
					x2="607.49"
					y2="630.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.49"
					y1="630.21"
					x2="554.04"
					y2="576.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.04"
					y1="576.76"
					x2="557.15"
					y2="573.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="573.64"
					x2="610.61"
					y2="627.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="544.55"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="544.55"
					y2="651.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="557.15"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="651.76"
					x2="557.15"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="651.76"
					x2="544.55"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="651.76"
					x2="544.55"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="544.55"
					y2="571.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="557.15"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="557.15"
					y1="571.12"
					x2="557.15"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="571.12"
					x2="544.55"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="544.55"
					y1="571.12"
					x2="544.55"
					y2="567.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="315.83"
					y1="875.73"
					x2="315.83"
					y2="857.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="315.83"
					y1="857.29"
					x2="303.23"
					y2="857.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.8"
					y1="875.73"
					x2="386.2"
					y2="875.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="386.2"
					y1="875.73"
					x2="315.83"
					y2="875.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="522.99"
					x2="281.18"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="268.58"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="442.35"
					x2="281.18"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="268.58"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="281.18"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="544.89"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="268.58"
					y2="544.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="282.44 443.61 282.44 438.57 281.18 438.57 281.18 443.61 282.44 443.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.18 521.73 281.18 526.77 282.44 526.77 282.44 521.73 281.18 521.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="268.58 443.61 268.58 438.57 267.32 438.57 267.32 443.61 268.58 443.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="267.32 521.73 267.32 526.77 268.58 526.77 268.58 521.73 267.32 521.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="282.44"
					y1="443.61"
					x2="282.44"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.44"
					y1="438.57"
					x2="281.18"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="438.57"
					x2="281.18"
					y2="443.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="443.61"
					x2="282.44"
					y2="443.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="521.73"
					x2="281.18"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="526.77"
					x2="282.44"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.44"
					y1="526.77"
					x2="282.44"
					y2="521.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.44"
					y1="521.73"
					x2="281.18"
					y2="521.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="443.61"
					x2="268.58"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="438.57"
					x2="267.32"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.32"
					y1="438.57"
					x2="267.32"
					y2="443.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.32"
					y1="443.61"
					x2="268.58"
					y2="443.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.32"
					y1="521.73"
					x2="267.32"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.32"
					y1="526.77"
					x2="268.58"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="526.77"
					x2="268.58"
					y2="521.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="521.73"
					x2="267.32"
					y2="521.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="281.18 444.87 281.18 442.98 268.58 442.98 268.58 444.87 281.18 444.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.18 522.36 281.18 520.47 268.58 520.47 268.58 522.36 281.18 522.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="215.12 467.01 268.58 520.47 271.69 517.35 218.24 463.89 215.12 467.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="268.58"
					y1="442.98"
					x2="268.58"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="442.98"
					x2="281.18"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="281.18"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="522.36"
					x2="268.58"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="522.36"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="444.87"
					x2="268.58"
					y2="444.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="444.87"
					x2="268.58"
					y2="442.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="442.98"
					x2="281.18"
					y2="442.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="442.98"
					x2="281.18"
					y2="444.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="522.36"
					x2="268.58"
					y2="522.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="522.36"
					x2="268.58"
					y2="520.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="520.47"
					x2="281.18"
					y2="520.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.18"
					y1="520.47"
					x2="281.18"
					y2="522.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.12"
					y1="467.01"
					x2="218.24"
					y2="463.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.24"
					y1="463.89"
					x2="271.69"
					y2="517.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.69"
					y1="517.35"
					x2="268.58"
					y2="520.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="520.47"
					x2="215.12"
					y2="467.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="281.18"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="281.18"
					y2="442.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="268.58"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="442.35"
					x2="268.58"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="442.35"
					x2="281.18"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="442.35"
					x2="281.18"
					y2="438.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="281.18"
					y2="522.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="268.58"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="268.58"
					y1="522.99"
					x2="268.58"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="522.99"
					x2="281.18"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="281.18"
					y1="522.99"
					x2="281.18"
					y2="526.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="508.05"
					y1="70.16"
					x2="508.05"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.75"
					y1="50"
					x2="368.75"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="675.58"
					y1="50"
					x2="675.58"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="263.11 561.03 205.61 561.03 205.61 617.54 263.11 617.54 263.11 561.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="263.11"
					y1="617.54"
					x2="263.11"
					y2="615.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="611.66"
					x2="263.11"
					y2="605.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="601.98"
					x2="263.11"
					y2="595.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="592.31"
					x2="263.11"
					y2="586.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="582.63"
					x2="263.11"
					y2="576.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="572.95"
					x2="263.11"
					y2="566.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="563.28"
					x2="263.11"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="617.54"
					x2="208.35"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.98"
					y1="617.54"
					x2="218.03"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.66"
					y1="617.54"
					x2="227.71"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.33"
					y1="617.54"
					x2="237.38"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.01"
					y1="617.54"
					x2="247.06"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.69"
					y1="617.54"
					x2="256.74"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.36"
					y1="617.54"
					x2="263.11"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="561.03"
					x2="205.61"
					y2="563.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="566.91"
					x2="205.61"
					y2="572.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="576.58"
					x2="205.61"
					y2="582.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="586.26"
					x2="205.61"
					y2="592.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="595.94"
					x2="205.61"
					y2="601.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="605.61"
					x2="205.61"
					y2="611.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="615.29"
					x2="205.61"
					y2="617.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="561.03"
					x2="260.36"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.74"
					y1="561.03"
					x2="250.69"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.06"
					y1="561.03"
					x2="241.01"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.38"
					y1="561.03"
					x2="231.33"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.71"
					y1="561.03"
					x2="221.66"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.03"
					y1="561.03"
					x2="211.98"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="561.03"
					x2="205.61"
					y2="561.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="266.09 617.33 267.82 617.33 267.82 561.24 266.09 561.24 266.09 570.04 267.51 570.04 267.51 608.53 266.09 608.53 266.09 617.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="266.09"
					y1="608.53"
					x2="266.09"
					y2="617.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="267.51"
					y1="608.53"
					x2="266.09"
					y2="608.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="267.51"
					y1="570.04"
					x2="267.51"
					y2="608.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="570.04"
					x2="267.51"
					y2="570.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="561.24"
					x2="266.09"
					y2="570.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="267.82"
					y1="561.24"
					x2="266.09"
					y2="561.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="267.82"
					y1="617.33"
					x2="267.82"
					y2="561.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="617.33"
					x2="267.82"
					y2="617.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<polyline
					points="266.09 619.52 266.09 559.05 263.11 559.05 263.11 619.52 266.09 619.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="263.11"
					y1="619.52"
					x2="266.09"
					y2="619.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="263.11"
					y1="559.05"
					x2="263.11"
					y2="619.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="559.05"
					x2="263.11"
					y2="559.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="619.52"
					x2="266.09"
					y2="559.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="266.09"
					y1="561.24"
					x2="267.82"
					y2="561.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.82"
					y1="561.24"
					x2="267.82"
					y2="617.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.82"
					y1="617.33"
					x2="266.09"
					y2="617.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="559.05"
					x2="266.09"
					y2="619.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="608.53"
					x2="267.51"
					y2="608.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.51"
					y1="608.53"
					x2="267.51"
					y2="570.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.51"
					y1="570.04"
					x2="266.09"
					y2="570.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="559.05"
					x2="266.09"
					y2="559.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="619.52"
					x2="263.11"
					y2="619.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.11"
					y1="619.52"
					x2="263.11"
					y2="559.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="398.8 787.41 315.83 787.41 315.83 875.73 398.8 875.73 398.8 787.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="398.8"
					y1="875.73"
					x2="398.8"
					y2="787.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.83"
					y1="875.73"
					x2="398.8"
					y2="875.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.83"
					y1="787.41"
					x2="315.83"
					y2="875.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.8"
					y1="787.41"
					x2="315.83"
					y2="787.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.8"
					y1="793.71"
					x2="315.83"
					y2="793.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.13 771 271.13 695.4 205.61 695.4 205.61 771 271.13 771"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.13"
					y1="771"
					x2="271.13"
					y2="695.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="771"
					x2="205.61"
					y2="695.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.59"
					y1="771"
					x2="207.59"
					y2="695.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.13"
					y1="771"
					x2="205.61"
					y2="771"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.13"
					y1="695.4"
					x2="205.61"
					y2="695.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.15"
					y1="766.04"
					x2="268.15"
					y2="700.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.15"
					y1="700.36"
					x2="266.17"
					y2="698.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.17"
					y1="698.38"
					x2="210.57"
					y2="698.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.57"
					y1="698.38"
					x2="208.58"
					y2="700.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.58"
					y1="700.36"
					x2="208.58"
					y2="766.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.58"
					y1="766.04"
					x2="210.57"
					y2="768.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.57"
					y1="768.03"
					x2="266.17"
					y2="768.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.17"
					y1="768.03"
					x2="268.15"
					y2="766.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m264.67,752.1c0-5.48-4.44-9.92-9.92-9.92s-9.92,4.44-9.92,9.92,4.44,9.92,9.92,9.92,9.92-4.44,9.92-9.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m229.43,752.1c0-4.11-3.33-7.44-7.44-7.44s-7.44,3.33-7.44,7.44,3.33,7.44,7.44,7.44,7.44-3.33,7.44-7.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m262.19,714.3c0-4.11-3.33-7.44-7.44-7.44s-7.44,3.33-7.44,7.44,3.33,7.44,7.44,7.44,7.44-3.33,7.44-7.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m231.91,714.3c0-5.48-4.44-9.92-9.92-9.92s-9.92,4.44-9.92,9.92,4.44,9.92,9.92,9.92,9.92-4.44,9.92-9.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="261.05 685.52 261.05 632.5 260.78 631.51 260.05 630.78 259.06 630.52 207.59 630.52 206.6 630.78 205.87 631.51 205.61 632.5 205.61 685.52 205.87 686.52 206.6 687.24 207.59 687.51 259.06 687.51 260.05 687.24 260.78 686.52 261.05 685.52"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m261.05,685.52c0,1.1-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.59"
					y1="687.51"
					x2="259.06"
					y2="687.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m207.59,687.51c-1.1,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="632.5"
					x2="205.61"
					y2="685.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m205.61,632.5c0-1.09.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.06"
					y1="630.52"
					x2="207.59"
					y2="630.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m259.06,630.52c1.1,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.05"
					y1="685.52"
					x2="261.05"
					y2="632.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.09"
					y1="680.56"
					x2="256.09"
					y2="637.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.1"
					y1="635.48"
					x2="217.51"
					y2="635.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.53"
					y1="637.46"
					x2="215.53"
					y2="680.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.51"
					y1="682.55"
					x2="254.1"
					y2="682.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.09"
					y1="680.56"
					x2="256.09"
					y2="680.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m254.1,635.48c1.1,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m215.53,637.46c0-1.1.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m217.51,682.55c-1.1,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m256.09,680.56c0,1.1-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m228.43,659.01c0-1.64-1.33-2.97-2.98-2.97s-2.98,1.33-2.98,2.97,1.33,2.98,2.98,2.98,2.98-1.33,2.98-2.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="228.22 659.91 228.85 659.64 229.11 659.01 228.84 658.38 228.21 658.12 208.58 658.12 207.95 658.38 207.69 659.01 207.95 659.64 208.58 659.91 228.22 659.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="208.58"
					y1="659.91"
					x2="228.22"
					y2="659.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m208.58,659.91c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.21"
					y1="658.12"
					x2="208.58"
					y2="658.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m228.21,658.12h0c.49,0,.89.4.89.89s-.4.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="213.64 660.99 213.64 659.91 208.58 659.91 207.95 659.64 207.69 659.01 207.95 658.38 208.58 658.12 213.64 658.12 213.64 657.03 207.19 657.03 207.19 660.99 213.64 660.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="207.19"
					y1="660.99"
					x2="213.64"
					y2="660.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.19"
					y1="657.03"
					x2="207.19"
					y2="660.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.64"
					y1="657.03"
					x2="207.19"
					y2="657.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.64"
					y1="658.12"
					x2="213.64"
					y2="657.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.58"
					y1="658.12"
					x2="213.64"
					y2="658.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m208.58,659.91c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.64"
					y1="659.91"
					x2="208.58"
					y2="659.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.64"
					y1="660.99"
					x2="213.64"
					y2="659.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="217.21 660.97 217.21 659.91 213.74 659.91 213.74 660.97 217.21 660.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.74"
					y1="660.97"
					x2="217.21"
					y2="660.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="659.91"
					x2="213.74"
					y2="660.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.21"
					y1="659.91"
					x2="213.74"
					y2="659.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.21"
					y1="660.97"
					x2="217.21"
					y2="659.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="217.21 657.06 213.74 657.06 213.74 658.12 217.21 658.12 217.21 657.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="217.21"
					y1="658.12"
					x2="217.21"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="658.12"
					x2="217.21"
					y2="658.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="657.06"
					x2="213.74"
					y2="658.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.21"
					y1="657.06"
					x2="213.74"
					y2="657.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="660.87 592.07 658.86 596.57 658.16 601.44 658.86 606.32 660.87 610.82 663.41 613.78 666.61 616.03 674.11 618.88 680.34 619.89 686.63 619.51 692.7 617.77 698.24 617.91 703.61 619.32 708.51 621.91 710.64 623.26 715.02 624.86 719.68 624.62 721.52 623.9 726.41 623.9 726.41 621.86 724.18 621.86 726.24 618.44 727.04 614.53 727.04 588.36 726.25 584.49 724.12 581.17 720.92 578.86 717.1 577.87 716.5 577.87 713.35 578.39 708.4 581.04 703.55 583.62 698.24 585.01 692.76 585.15 686.68 583.38 680.36 583 674.11 584.01 666.61 586.86 663.41 589.11 660.87 592.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="703.77"
					y1="610.77"
					x2="703.77"
					y2="592.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="588.36"
					x2="727.04"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.1"
					y1="588.36"
					x2="726.1"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="614.53"
					x2="727.04"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.1"
					y1="614.53"
					x2="726.1"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.77"
					y1="592.6"
					x2="707.26"
					y2="592.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.26"
					y1="592.6"
					x2="707.26"
					y2="595.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.26"
					y1="595.48"
					x2="703.77"
					y2="595.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.77"
					y1="610.29"
					x2="707.26"
					y2="610.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.26"
					y1="610.29"
					x2="707.26"
					y2="607.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.26"
					y1="607.41"
					x2="703.77"
					y2="607.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.74"
					y1="621.86"
					x2="726.41"
					y2="621.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.74"
					y1="623.9"
					x2="726.41"
					y2="623.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.41"
					y1="623.9"
					x2="726.41"
					y2="621.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.74"
					y1="623.9"
					x2="717.74"
					y2="621.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.16"
					y1="601.44"
					x2="658.52"
					y2="598.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.52"
					y1="598.32"
					x2="659.33"
					y2="595.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.33"
					y1="595.29"
					x2="660.87"
					y2="592.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.87"
					y1="592.07"
					x2="663.41"
					y2="589.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.41"
					y1="589.1"
					x2="666.61"
					y2="586.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.61"
					y1="586.86"
					x2="670.24"
					y2="585.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.24"
					y1="585.21"
					x2="674.11"
					y2="584.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.11"
					y1="584.01"
					x2="680.35"
					y2="582.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.35"
					y1="582.92"
					x2="683.5"
					y2="582.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.5"
					y1="582.86"
					x2="686.63"
					y2="583.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.63"
					y1="583.21"
					x2="691.5"
					y2="584.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.5"
					y1="584.63"
					x2="696.2"
					y2="586.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.2"
					y1="586.84"
					x2="700.41"
					y2="589.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.41"
					y1="589.46"
					x2="703.77"
					y2="592.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.76"
					y1="585.15"
					x2="697.13"
					y2="585.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.13"
					y1="585.12"
					x2="701.38"
					y2="584.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="584.4"
					x2="703.67"
					y2="583.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.67"
					y1="583.66"
					x2="705.93"
					y2="582.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.93"
					y1="582.59"
					x2="709.24"
					y2="580.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.24"
					y1="580.49"
					x2="712.65"
					y2="578.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.65"
					y1="578.63"
					x2="715.99"
					y2="577.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.99"
					y1="577.89"
					x2="719.31"
					y2="578.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.31"
					y1="578.17"
					x2="722.34"
					y2="579.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.34"
					y1="579.47"
					x2="723.64"
					y2="580.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.64"
					y1="580.49"
					x2="724.76"
					y2="581.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.76"
					y1="581.75"
					x2="726"
					y2="583.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726"
					y1="583.99"
					x2="726.69"
					y2="586.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.69"
					y1="586.12"
					x2="727.04"
					y2="588.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.1"
					y1="588.36"
					x2="726"
					y2="587.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726"
					y1="587.36"
					x2="725.37"
					y2="585.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.37"
					y1="585.3"
					x2="723.83"
					y2="583.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.83"
					y1="583.48"
					x2="721.7"
					y2="582.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.7"
					y1="582.34"
					x2="718.89"
					y2="581.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.89"
					y1="581.8"
					x2="715.99"
					y2="581.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.99"
					y1="581.67"
					x2="714.55"
					y2="581.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.55"
					y1="581.69"
					x2="713.41"
					y2="582.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.41"
					y1="582.3"
					x2="713.08"
					y2="583.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.08"
					y1="583.01"
					x2="710.83"
					y2="590.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.83"
					y1="590.92"
					x2="710.16"
					y2="594.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.16"
					y1="594.86"
					x2="709.87"
					y2="598.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.87"
					y1="598.84"
					x2="709.87"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.7"
					y1="617.77"
					x2="697.08"
					y2="617.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.08"
					y1="617.8"
					x2="701.35"
					y2="618.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.35"
					y1="618.52"
					x2="703.65"
					y2="619.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.65"
					y1="619.25"
					x2="705.93"
					y2="620.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.93"
					y1="620.3"
					x2="709.24"
					y2="622.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.24"
					y1="622.39"
					x2="712.65"
					y2="624.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.65"
					y1="624.26"
					x2="714.88"
					y2="624.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.88"
					y1="624.87"
					x2="717.17"
					y2="625.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.17"
					y1="625.02"
					x2="719.41"
					y2="624.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.41"
					y1="624.69"
					x2="721.52"
					y2="623.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.1"
					y1="614.53"
					x2="726"
					y2="615.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726"
					y1="615.53"
					x2="725.37"
					y2="617.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.37"
					y1="617.59"
					x2="723.83"
					y2="619.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.83"
					y1="619.41"
					x2="721.7"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.7"
					y1="620.55"
					x2="718.89"
					y2="621.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.89"
					y1="621.09"
					x2="715.99"
					y2="621.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.99"
					y1="621.22"
					x2="714.55"
					y2="621.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.55"
					y1="621.2"
					x2="713.41"
					y2="620.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.41"
					y1="620.59"
					x2="713.08"
					y2="619.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.08"
					y1="619.88"
					x2="710.83"
					y2="611.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.83"
					y1="611.97"
					x2="710.16"
					y2="608.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.16"
					y1="608.03"
					x2="709.87"
					y2="604.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.87"
					y1="604.05"
					x2="709.87"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.16"
					y1="601.44"
					x2="658.52"
					y2="604.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.52"
					y1="604.57"
					x2="659.33"
					y2="607.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.33"
					y1="607.6"
					x2="660.87"
					y2="610.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.87"
					y1="610.82"
					x2="663.41"
					y2="613.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.41"
					y1="613.78"
					x2="666.61"
					y2="616.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.61"
					y1="616.03"
					x2="670.24"
					y2="617.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.24"
					y1="617.68"
					x2="674.11"
					y2="618.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.11"
					y1="618.88"
					x2="680.35"
					y2="619.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.35"
					y1="619.97"
					x2="683.5"
					y2="620.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.5"
					y1="620.03"
					x2="686.63"
					y2="619.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.63"
					y1="619.68"
					x2="691.5"
					y2="618.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.5"
					y1="618.26"
					x2="696.2"
					y2="616.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.2"
					y1="616.05"
					x2="700.41"
					y2="613.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.41"
					y1="613.43"
					x2="703.77"
					y2="610.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.84"
					y1="579.51"
					x2="710.12"
					y2="580.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.12"
					y1="580.01"
					x2="709.06"
					y2="581.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.06"
					y1="581.45"
					x2="708.81"
					y2="582.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.81"
					y1="582.7"
					x2="708.13"
					y2="590.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.13"
					y1="590.74"
					x2="707.81"
					y2="598.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.81"
					y1="598.8"
					x2="707.81"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.84"
					y1="623.38"
					x2="710.12"
					y2="622.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.12"
					y1="622.88"
					x2="709.06"
					y2="621.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.06"
					y1="621.44"
					x2="708.81"
					y2="620.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.81"
					y1="620.19"
					x2="708.13"
					y2="612.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.13"
					y1="612.15"
					x2="707.81"
					y2="604.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.81"
					y1="604.09"
					x2="707.81"
					y2="601.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.18"
					y1="621.86"
					x2="724.76"
					y2="621.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.76"
					y1="621.14"
					x2="726"
					y2="618.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726"
					y1="618.9"
					x2="726.69"
					y2="616.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.69"
					y1="616.77"
					x2="727.04"
					y2="614.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="679.2 646.18 679.2 711.73 727.04 711.73 727.04 646.18 679.2 646.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="679.2"
					y1="646.18"
					x2="679.2"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="646.18"
					x2="727.04"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.2"
					y1="711.73"
					x2="727.04"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.2"
					y1="646.18"
					x2="727.04"
					y2="646.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.06"
					y1="646.18"
					x2="725.06"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.89"
					y1="653.76"
					x2="689.89"
					y2="704.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.89"
					y1="704.16"
					x2="720.13"
					y2="704.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.13"
					y1="704.16"
					x2="720.13"
					y2="653.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.13"
					y1="653.76"
					x2="689.89"
					y2="653.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.91"
					y1="651.77"
					x2="687.91"
					y2="706.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.91"
					y1="706.14"
					x2="722.12"
					y2="706.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.12"
					y1="706.14"
					x2="722.12"
					y2="651.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.12"
					y1="651.77"
					x2="687.91"
					y2="651.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m716.28,678.96c0-1.64-1.33-2.97-2.98-2.97s-2.97,1.33-2.97,2.97,1.33,2.98,2.97,2.98,2.98-1.33,2.98-2.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="725.03 676.48 720.87 676.88 719.92 677.2 714.67 677.85 713.98 678.22 713.7 678.96 713.98 679.69 714.67 680.06 719.92 680.72 720.87 681.04 725.03 681.44 726.49 680.96 727.39 679.72 727.39 678.19 726.49 676.95 725.03 676.48"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m725.03,676.48c1.37,0,2.48,1.11,2.48,2.48s-1.11,2.48-2.48,2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.87"
					y1="681.04"
					x2="725.03"
					y2="681.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m720.87,681.04c-.33-.03-.66-.14-.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.67"
					y1="680.06"
					x2="719.92"
					y2="680.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m714.67,680.06c-.56-.07-.97-.54-.97-1.1s.42-1.03.97-1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.92"
					y1="677.2"
					x2="714.67"
					y2="677.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m719.92,677.2c.28-.19.61-.3.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.03"
					y1="676.48"
					x2="720.87"
					y2="676.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.56"
					y1="680.31"
					x2="721.08"
					y2="680.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.08"
					y1="677.61"
					x2="722.56"
					y2="677.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.56"
					y1="677.61"
					x2="722.56"
					y2="680.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m721.08,680.31c-.75,0-1.35-.6-1.35-1.35s.6-1.35,1.35-1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m719.92,680.72c-.6-.38-.96-1.05-.96-1.76s.36-1.37.96-1.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="727.04 571.2 726.04 571.2 726.04 576.24 727.04 576.24 727.04 571.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="727.04"
					y1="576.24"
					x2="727.04"
					y2="571.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="576.24"
					x2="727.04"
					y2="576.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="571.2"
					x2="726.04"
					y2="576.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="571.2"
					x2="726.04"
					y2="571.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="727.04 631.68 727.04 626.64 726.04 626.64 726.04 631.68 727.04 631.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="726.04"
					y1="631.68"
					x2="727.04"
					y2="631.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="626.64"
					x2="726.04"
					y2="631.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="626.64"
					x2="726.04"
					y2="626.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.04"
					y1="631.68"
					x2="727.04"
					y2="626.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="726.04 573.22 717.84 573.22 717.84 574.23 726.04 574.23 726.04 573.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="726.04"
					y1="574.23"
					x2="726.04"
					y2="573.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.84"
					y1="574.23"
					x2="726.04"
					y2="574.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.84"
					y1="573.22"
					x2="717.84"
					y2="574.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="573.22"
					x2="717.84"
					y2="573.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="726.04 629.67 726.04 628.66 717.84 628.66 717.84 629.67 726.04 629.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="717.84"
					y1="629.67"
					x2="726.04"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.84"
					y1="628.66"
					x2="717.84"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="628.66"
					x2="717.84"
					y2="628.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.04"
					y1="629.67"
					x2="726.04"
					y2="628.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="720.35 574.23 718.34 574.23 718.34 628.66 720.35 628.66 720.35 574.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="720.35"
					y1="628.66"
					x2="720.35"
					y2="574.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.34"
					y1="628.66"
					x2="720.35"
					y2="628.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.34"
					y1="574.23"
					x2="718.34"
					y2="628.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.35"
					y1="574.23"
					x2="718.34"
					y2="574.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="557.15 711.73 557.15 791.92 711.81 791.92 711.81 711.73 557.15 711.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.81"
					y1="711.73"
					x2="557.15"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="791.92"
					x2="711.81"
					y2="711.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="791.92"
					x2="711.81"
					y2="791.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.15"
					y1="711.73"
					x2="557.15"
					y2="791.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.85"
					y1="716.69"
					x2="562.11"
					y2="716.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.11"
					y1="716.69"
					x2="562.11"
					y2="786.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.11"
					y1="786.95"
					x2="706.85"
					y2="786.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.85"
					y1="786.95"
					x2="706.85"
					y2="716.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.85"
					y1="716.69"
					x2="641.72"
					y2="748.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.85"
					y1="786.95"
					x2="641.72"
					y2="755.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.11"
					y1="716.69"
					x2="627.24"
					y2="748.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.11"
					y1="786.95"
					x2="627.24"
					y2="755.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.48"
					y1="746.86"
					x2="634.48"
					y2="756.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.52"
					y1="751.82"
					x2="639.44"
					y2="751.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m642.42,751.82c0-4.38-3.55-7.94-7.94-7.94s-7.94,3.55-7.94,7.94,3.55,7.94,7.94,7.94,7.94-3.55,7.94-7.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m639.44,751.82c0-2.74-2.22-4.96-4.96-4.96s-4.96,2.22-4.96,4.96,2.22,4.96,4.96,4.96,4.96-2.22,4.96-4.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="711.81 751.82 701.28 744.08 701.28 759.57 711.81 751.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.28"
					y1="759.57"
					x2="711.81"
					y2="751.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.28"
					y1="744.08"
					x2="701.28"
					y2="759.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.81"
					y1="751.82"
					x2="701.28"
					y2="744.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.88"
					y1="751.82"
					x2="692.41"
					y2="751.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.28"
					y1="751.82"
					x2="701.28"
					y2="759.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.28"
					y1="759.57"
					x2="711.81"
					y2="751.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.28"
					y1="751.82"
					x2="701.28"
					y2="744.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.28"
					y1="744.08"
					x2="711.81"
					y2="751.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.08"
					y1="754.11"
					x2="693.48"
					y2="757.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.08"
					y1="749.54"
					x2="693.48"
					y2="746.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.56"
					y1="845.88"
					x2="736.91"
					y2="845.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.91"
					y1="845.88"
					x2="736.91"
					y2="893.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.56"
					y1="835.8"
					x2="754.56"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.91"
					y1="903.85"
					x2="799.91"
					y2="835.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.91"
					y1="835.8"
					x2="731.87"
					y2="835.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.87"
					y1="903.85"
					x2="799.91"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.14"
					y1="835.8"
					x2="733.14"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.56"
					y1="893.77"
					x2="736.91"
					y2="893.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.87"
					y1="835.8"
					x2="731.87"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.35"
					y1="787.41"
					x2="318.35"
					y2="782.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.35"
					y1="782.43"
					x2="320.87"
					y2="782.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.87"
					y1="782.43"
					x2="320.87"
					y2="787.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.8"
					y1="796.81"
					x2="393"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.37"
					y1="796.81"
					x2="383.32"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.69"
					y1="796.81"
					x2="373.64"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.02"
					y1="796.81"
					x2="363.97"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.34"
					y1="796.81"
					x2="354.29"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.66"
					y1="796.81"
					x2="344.61"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.98"
					y1="796.81"
					x2="334.94"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.31"
					y1="796.81"
					x2="325.26"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.63"
					y1="796.81"
					x2="315.83"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.83"
					y1="827.05"
					x2="311.52"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.89"
					y1="827.05"
					x2="301.84"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.21"
					y1="827.05"
					x2="292.17"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.54"
					y1="827.05"
					x2="282.49"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.86"
					y1="827.05"
					x2="272.81"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.18"
					y1="827.05"
					x2="263.14"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.51"
					y1="827.05"
					x2="253.46"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.83"
					y1="827.05"
					x2="243.78"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.15"
					y1="827.05"
					x2="235.85"
					y2="827.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.83"
					y1="796.81"
					x2="266.09"
					y2="796.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="827.05"
					x2="235.85"
					y2="824.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="821.09"
					x2="235.85"
					y2="815.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="811.42"
					x2="235.85"
					y2="805.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="801.74"
					x2="235.85"
					y2="795.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="792.06"
					x2="235.85"
					y2="786.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="782.38"
					x2="235.85"
					y2="776.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="772.71"
					x2="235.85"
					y2="766.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="763.03"
					x2="235.85"
					y2="756.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="753.35"
					x2="235.85"
					y2="747.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="743.68"
					x2="235.85"
					y2="737.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="734"
					x2="235.85"
					y2="727.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="724.32"
					x2="235.85"
					y2="718.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="714.65"
					x2="235.85"
					y2="708.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="704.97"
					x2="235.85"
					y2="698.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="695.29"
					x2="235.85"
					y2="689.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="685.62"
					x2="235.85"
					y2="679.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="675.94"
					x2="235.85"
					y2="669.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="666.26"
					x2="235.85"
					y2="660.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="656.59"
					x2="235.85"
					y2="650.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="646.91"
					x2="235.85"
					y2="640.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="637.23"
					x2="235.85"
					y2="631.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="627.56"
					x2="235.85"
					y2="621.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="617.88"
					x2="235.85"
					y2="611.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="608.2"
					x2="235.85"
					y2="602.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="598.52"
					x2="235.85"
					y2="592.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="588.85"
					x2="235.85"
					y2="582.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="579.17"
					x2="235.85"
					y2="573.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="569.49"
					x2="235.85"
					y2="563.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.85"
					y1="559.81"
					x2="235.85"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="796.81"
					x2="266.09"
					y2="771"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="695.4"
					x2="266.09"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.22"
					y1="50"
					x2="368.75"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.75"
					y1="70.16"
					x2="201.22"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.05"
					y1="50"
					x2="675.58"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.58"
					y1="70.16"
					x2="509.12"
					y2="70.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.36"
					y1="845.88"
					x2="792.36"
					y2="893.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.36"
					y1="893.77"
					x2="759.6"
					y2="893.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.6"
					y1="893.77"
					x2="759.6"
					y2="845.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.6"
					y1="845.88"
					x2="792.36"
					y2="845.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="605.59 928.58 605.59 948.74 435.37 948.74 435.37 921.02 138.05 921.02 138.05 50 201.22 50 201.22 70.16 158.22 70.16 158.22 380.84 281.18 380.84 281.18 442.35 268.58 442.35 268.58 393.44 158.22 393.44 158.22 544.89 268.58 544.89 268.58 522.99 281.18 522.99 281.18 544.89 343.5 544.89 343.5 557.49 205.6 557.49 205.6 857.28 315.83 857.28 315.83 875.73 398.8 875.73 398.8 900.87 455.53 900.87 455.53 928.58 605.59 928.58"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.12"
				/>
				<polygon
					points="508.05 50 508.05 70.16 481.67 70.16 481.67 151.7 451 151.7 451 544.89 457.78 544.89 457.78 557.49 424.14 557.49 424.14 544.89 438.4 544.89 438.4 151.7 409.56 151.7 409.56 70.16 368.75 70.16 368.75 50 508.05 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.12"
				/>
				<polygon
					points="861.95 810.07 861.95 948.74 701.35 948.74 701.35 928.58 711.81 928.58 711.81 905.33 724.4 905.33 724.4 928.58 841.78 928.58 841.78 830.22 724.4 830.22 724.4 834.76 711.81 834.76 711.81 804.52 544.56 804.52 544.56 651.76 557.16 651.76 557.16 791.92 711.81 791.92 711.81 711.74 727.04 711.74 727.04 557.49 557.16 557.49 557.16 571.11 544.56 571.11 544.56 557.49 538.42 557.49 538.42 544.89 751.15 544.89 751.15 70.16 675.58 70.16 675.58 50 771.32 50 771.32 810.07 861.95 810.07"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.12"
				/>
			</g>
			<g id="text">
				<path d="m225.55,594.56v-11.69h4.03c.91,0,1.6.06,2.08.17.67.15,1.24.43,1.72.84.62.52,1.08,1.19,1.38,2,.31.81.46,1.73.46,2.78,0,.89-.1,1.68-.31,2.36-.21.69-.47,1.26-.8,1.71-.32.45-.68.8-1.07,1.06-.38.26-.85.45-1.4.58-.54.13-1.17.2-1.87.2h-4.22Zm1.55-1.38h2.5c.77,0,1.37-.07,1.81-.22.44-.14.79-.35,1.05-.61.37-.37.65-.86.85-1.48.21-.62.31-1.37.31-2.26,0-1.22-.2-2.16-.61-2.82-.4-.66-.89-1.1-1.46-1.32-.41-.16-1.08-.24-2-.24h-2.46v8.93Zm12.29,1.38l-3.1-11.69h1.59l1.78,7.67c.19.8.36,1.6.49,2.39.3-1.25.47-1.97.53-2.16l2.23-7.9h1.87l1.68,5.92c.42,1.47.72,2.85.91,4.14.15-.74.34-1.59.58-2.54l1.83-7.51h1.56l-3.21,11.69h-1.49l-2.46-8.91c-.21-.74-.33-1.2-.37-1.37-.12.54-.24.99-.34,1.37l-2.48,8.91h-1.58Z" />
				<path d="m353.63,838.57h-1.64l-1.97-3.3c-.18-.31-.36-.57-.53-.78-.17-.22-.34-.4-.53-.53-.18-.14-.37-.24-.57-.3-.2-.07-.43-.1-.69-.1h-1.13v5.01h-1.38v-11.77h3.51c.51,0,.99.07,1.42.2.44.13.82.32,1.13.58.32.26.57.59.76.99.18.39.27.85.27,1.37,0,.41-.06.79-.19,1.13-.12.34-.3.64-.53.91-.22.27-.5.5-.82.69-.32.19-.68.33-1.08.44v.03c.2.09.37.19.51.3.15.11.29.24.42.39.13.15.26.33.39.53.13.19.28.42.44.67l2.21,3.54Zm-7.06-10.53v4.27h1.87c.34,0,.66-.05.95-.16.3-.1.55-.25.76-.44.21-.2.38-.44.5-.71.12-.28.18-.6.18-.95,0-.63-.21-1.12-.62-1.47-.41-.36-.99-.53-1.77-.53h-1.89Zm15.1,6.66h-5.94c.02.94.27,1.66.76,2.17s1.14.76,1.99.76c.95,0,1.82-.31,2.61-.94v1.26c-.74.54-1.72.8-2.93.8s-2.12-.38-2.8-1.14c-.68-.77-1.02-1.84-1.02-3.23,0-1.31.37-2.37,1.11-3.19.74-.83,1.67-1.24,2.77-1.24s1.95.36,2.55,1.07.9,1.7.9,2.96v.71Zm-1.38-1.14c0-.78-.19-1.38-.57-1.81-.37-.43-.88-.65-1.54-.65s-1.17.23-1.62.68-.72,1.05-.82,1.78h4.54Zm7.41-6.26c-.26-.15-.56-.22-.89-.22-.94,0-1.41.59-1.41,1.78v1.3h1.97v1.15h-1.97v7.26h-1.34v-7.26h-1.44v-1.15h1.44v-1.36c0-.88.25-1.58.76-2.09.51-.51,1.14-.77,1.9-.77.41,0,.74.05.98.15v1.22Z" />
				<path d="m369.12,838.75c-.25,0-.47-.09-.65-.27-.18-.18-.26-.4-.26-.65s.09-.47.26-.65c.18-.19.4-.28.65-.28s.48.09.66.28c.18.18.27.4.27.65s-.09.47-.27.65c-.18.18-.4.27-.66.27Z" />
				<path d="m620.65,649.38v-18.27h5.2c1.58,0,2.83.39,3.76,1.16.93.77,1.39,1.78,1.39,3.02,0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.24,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.5-2.66h-2.46Zm0,7.82v6.57h2.91c1.26,0,2.23-.3,2.92-.89.7-.59,1.04-1.41,1.04-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm21.87,8.51h-2.09v-2.04h-.05c-.91,1.56-2.25,2.34-4.01,2.34-1.3,0-2.32-.34-3.06-1.03-.73-.69-1.1-1.6-1.1-2.74,0-2.44,1.44-3.86,4.31-4.26l3.91-.55c0-2.22-.9-3.33-2.69-3.33-1.57,0-2.99.54-4.26,1.61v-2.14c1.28-.82,2.76-1.22,4.43-1.22,3.07,0,4.6,1.62,4.6,4.87v8.49Zm-2.09-6.6l-3.15.43c-.97.14-1.7.38-2.19.73-.49.34-.74.95-.74,1.82,0,.64.23,1.16.68,1.57.46.4,1.07.6,1.82.6,1.04,0,1.89-.36,2.56-1.08.68-.73,1.02-1.65,1.02-2.77v-1.3Zm12.08,6.47c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.72h-2.24v-1.78h2.24v-3.19l2.09-.68v3.86h3.29v1.78h-3.29v7.35c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm13.62.13h-2.09v-7.52c0-2.72-1.01-4.08-3.03-4.08-1.02,0-1.88.39-2.57,1.18-.7.78-1.04,1.79-1.04,3.02v7.39h-2.09v-19.32h2.09v8.44h.05c1-1.65,2.43-2.47,4.28-2.47,2.94,0,4.41,1.77,4.41,5.31v8.04Z" />
				<path d="m550.51,302.65v-18.27h5.2c1.58,0,2.83.39,3.76,1.16s1.39,1.78,1.39,3.02c0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.24,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.5-2.66h-2.46Zm0,7.82v6.57h2.91c1.26,0,2.23-.3,2.92-.89.7-.59,1.04-1.41,1.04-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm22.99,2.51h-9.21c.03,1.45.42,2.57,1.17,3.36.75.79,1.78,1.19,3.08,1.19,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.92,4.29-1.92s3.03.55,3.96,1.66c.93,1.1,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.14-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.71-1.11,1.63-1.27,2.77h7.05Zm16.41,7.77h-2.09v-2.22h-.05c-.97,1.68-2.46,2.52-4.49,2.52-1.64,0-2.95-.58-3.94-1.75-.98-1.17-1.47-2.77-1.47-4.78,0-2.16.54-3.89,1.63-5.19s2.54-1.95,4.35-1.95,3.1.71,3.91,2.12h.05v-8.08h2.09v19.32Zm-2.09-5.9v-1.92c0-1.05-.35-1.95-1.04-2.68-.7-.73-1.58-1.1-2.65-1.1-1.27,0-2.28.47-3.01,1.4-.73.93-1.1,2.23-1.1,3.87,0,1.5.35,2.69,1.04,3.57.7.87,1.65,1.3,2.83,1.3s2.11-.42,2.83-1.26c.73-.84,1.1-1.9,1.1-3.19Zm13.1-5.03c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.65h-2.09v-13.05h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm7.71,11.24c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.8-5.14,1.2-1.23,2.82-1.85,4.85-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.98s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.9c-1.34,0-2.4.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.87,1.1-2.12,1.1-3.73s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm15.11,11.9c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.8-5.14s2.82-1.85,4.85-1.85,3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.98s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.9c-1.34,0-2.4.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.87,1.1-2.12,1.1-3.73s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm28.19,11.6h-2.09v-7.49c0-1.44-.23-2.49-.68-3.13-.44-.65-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.82-.93,1.79-.93,2.93v7.44h-2.09v-7.75c0-2.57-.99-3.85-2.97-3.85-.92,0-1.67.39-2.27,1.16-.59.76-.89,1.76-.89,2.99v7.44h-2.09v-13.05h2.09v2.06h.05c.93-1.58,2.28-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.31,1.77,4.31,5.31v8.04Z" />
				<path d="m558.33,322.29c0,1.22-.12,2.3-.36,3.25-.24.95-.59,1.75-1.06,2.41-.46.65-1.03,1.16-1.7,1.5-.67.34-1.43.51-2.28.51s-1.65-.15-2.32-.46v-1.46c.74.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.48-.25.88-.61,1.2-1.08.33-.48.58-1.06.75-1.75.17-.69.26-1.49.26-2.38h-.04c-.57,1.14-1.56,1.71-2.97,1.71-.57,0-1.09-.1-1.57-.3-.48-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.81-1.32-.19-.51-.29-1.07-.29-1.68,0-.65.1-1.25.32-1.8.22-.54.51-1.01.89-1.4.38-.4.83-.7,1.35-.92.53-.22,1.1-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.31,1.18.35.51.62,1.15.81,1.9.19.75.28,1.62.28,2.59Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.08-.23-.3-.52-.53-.84-.7-.32-.17-.67-.25-1.06-.25s-.7.07-1.02.22c-.32.14-.59.35-.82.61-.23.26-.41.57-.55.94-.13.36-.19.75-.19,1.18,0,.47.06.89.19,1.26.13.37.31.69.55.95.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.32-.14.59-.32.82-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="560.78" y="316.44" width="1.34" height="4.14" />
				<path d="m570.28,329.73h-1.52v-11.48c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.59Zm10.25,0h-1.52v-11.48c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.59Z" />
				<path d="m586.92,316.44v4.14h-1.34v-4.14h1.34Zm3.08,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m605.19,320.24l-3.19,4.8,3.13,4.69h-1.77l-1.86-3.08c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.44.72l-1.9,3.08h-1.75l3.23-4.65-3.1-4.84h1.77l1.84,3.24c.14.24.27.49.4.74h.04l2.37-3.99h1.68Z" />
				<path d="m617.34,329.73h-1.52v-11.48c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.59Zm12.52-4.06c0,.65-.11,1.24-.33,1.76-.22.53-.54.98-.95,1.35-.41.38-.9.67-1.48.87-.58.2-1.23.31-1.94.31-1.24,0-2.15-.19-2.75-.56v-1.61c.9.58,1.83.87,2.77.87.48,0,.91-.07,1.3-.21.39-.14.72-.34.99-.59.27-.25.48-.56.62-.92.15-.36.22-.75.22-1.18,0-.87-.29-1.54-.87-2.03-.58-.49-1.42-.74-2.53-.74-.18,0-.37,0-.57,0-.2,0-.4.02-.59.03-.2,0-.39.02-.58.03-.19.01-.36.03-.51.05l.45-6.66h6.15v1.37h-4.83l-.27,3.9c.2-.01.41-.02.63-.03.22-.01.42-.02.59-.02.7,0,1.33.09,1.89.28.56.19,1.03.45,1.41.8.39.34.68.76.88,1.26.2.49.31,1.05.31,1.67Z" />
				<rect x="632.63" y="316.44" width="1.34" height="4.14" />
				<path d="m644.73,322.29c0,1.22-.12,2.3-.36,3.25-.24.95-.59,1.75-1.06,2.41-.46.65-1.03,1.16-1.7,1.5-.67.34-1.43.51-2.28.51s-1.65-.15-2.32-.46v-1.46c.74.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.48-.25.88-.61,1.2-1.08.33-.48.58-1.06.75-1.75.17-.69.26-1.49.26-2.38h-.04c-.57,1.14-1.56,1.71-2.97,1.71-.57,0-1.09-.1-1.57-.3-.48-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.81-1.32s-.29-1.07-.29-1.68c0-.65.1-1.25.32-1.8.22-.54.51-1.01.89-1.4.38-.4.83-.7,1.35-.92.53-.22,1.1-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.31,1.18.35.51.62,1.15.81,1.9.19.75.28,1.62.28,2.59Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.08-.23-.3-.52-.53-.84-.7-.32-.17-.67-.25-1.06-.25s-.7.07-1.02.22c-.32.14-.59.35-.82.61-.23.26-.41.57-.55.94-.13.36-.19.75-.19,1.18,0,.47.06.89.19,1.26.13.37.31.69.55.95.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.32-.14.59-.32.82-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<path d="m648.52,316.44v4.14h-1.34v-4.14h1.34Zm3.08,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m213.5,506.98l-3.28,11.63h-1.6l-2.39-8.5c-.1-.36-.16-.76-.19-1.18h-.03c-.03.4-.1.79-.21,1.17l-2.41,8.51h-1.58l-3.41-11.63h1.5l2.47,8.92c.1.37.17.76.19,1.17h.04c.03-.29.11-.68.25-1.17l2.57-8.92h1.31l2.46,8.98c.09.31.15.67.19,1.09h.03c.02-.28.09-.65.22-1.12l2.38-8.95h1.48Zm7.31,11.63h-1.33v-1.3h-.03c-.58.99-1.43,1.49-2.55,1.49-.83,0-1.48-.22-1.95-.66-.46-.44-.7-1.02-.7-1.74,0-1.55.91-2.45,2.74-2.71l2.49-.35c0-1.41-.57-2.12-1.71-2.12-1,0-1.9.34-2.71,1.02v-1.36c.82-.52,1.76-.78,2.82-.78,1.95,0,2.93,1.03,2.93,3.1v5.4Zm-1.33-4.2l-2,.28c-.62.09-1.08.24-1.39.46-.31.22-.47.6-.47,1.16,0,.41.14.74.43,1,.29.25.68.38,1.16.38.66,0,1.2-.23,1.63-.69.43-.46.65-1.05.65-1.76v-.83Zm4.99,4.2h-1.33v-12.29h1.33v12.29Zm9.41,0h-1.86l-3.66-3.99h-.03v3.99h-1.33v-12.29h1.33v7.79h.03l3.49-3.8h1.74l-3.85,4.01,4.15,4.3Z" />
				<rect x="234.89" y="513.45" width="4.43" height="1.05" />
				<path d="m243.25,518.6h-1.36v-11.63h1.36v11.63Zm9.78,0h-1.33v-4.73c0-1.76-.64-2.64-1.93-2.64-.66,0-1.22.25-1.65.75-.43.5-.65,1.13-.65,1.89v4.73h-1.33v-8.3h1.33v1.38h.03c.63-1.05,1.54-1.57,2.72-1.57.91,0,1.6.29,2.08.88.48.58.72,1.43.72,2.54v5.08Z" />
				<path d="m212.95,540.25c-.86.45-1.93.68-3.21.68-1.65,0-2.98-.53-3.97-1.6-.99-1.06-1.49-2.46-1.49-4.19,0-1.86.56-3.36,1.68-4.51,1.12-1.15,2.54-1.72,4.26-1.72,1.1,0,2.02.16,2.74.48v1.45c-.83-.46-1.75-.7-2.76-.7-1.34,0-2.42.45-3.25,1.34-.83.89-1.24,2.08-1.24,3.58s.39,2.55,1.16,3.39c.78.84,1.8,1.26,3.06,1.26,1.17,0,2.18-.26,3.03-.78v1.32Zm3.52.49h-1.33v-12.29h1.33v12.29Zm6.16.19c-1.23,0-2.21-.39-2.94-1.16-.73-.78-1.09-1.81-1.09-3.09,0-1.39.38-2.48,1.14-3.27s1.79-1.18,3.09-1.18,2.2.38,2.89,1.14c.7.76,1.05,1.82,1.05,3.17s-.38,2.39-1.13,3.19c-.75.79-1.75,1.19-3.01,1.19Zm.1-7.57c-.85,0-1.53.29-2.03.88-.5.58-.75,1.38-.75,2.4s.25,1.76.75,2.33c.5.57,1.18.85,2.02.85s1.52-.28,1.98-.84c.46-.56.7-1.35.7-2.38s-.23-1.84-.7-2.4c-.46-.56-1.12-.84-1.98-.84Zm5.66,7.08v-1.43c.72.54,1.52.8,2.39.8,1.17,0,1.75-.39,1.75-1.17,0-.22-.05-.41-.15-.56-.1-.16-.23-.29-.41-.41-.17-.12-.37-.22-.6-.32-.23-.1-.47-.2-.74-.3-.37-.15-.69-.29-.97-.44-.28-.15-.51-.32-.7-.5-.18-.19-.32-.4-.42-.64-.09-.24-.14-.52-.14-.84,0-.39.09-.73.27-1.03.18-.3.42-.55.71-.75.3-.21.64-.36,1.01-.46.38-.1.78-.15,1.18-.15.72,0,1.36.12,1.93.37v1.35c-.61-.4-1.31-.6-2.11-.6-.25,0-.47.03-.67.09-.2.05-.37.13-.52.24-.14.1-.25.23-.33.37-.08.14-.11.3-.11.47,0,.22.04.4.11.54.08.15.2.28.35.39.15.11.34.22.55.31.22.09.46.19.74.3.37.14.7.29.99.44.29.15.54.31.75.5.21.18.36.4.47.64.11.24.17.53.17.87,0,.41-.09.77-.28,1.07-.18.3-.42.55-.72.75-.3.2-.65.35-1.05.45-.39.1-.81.15-1.24.15-.85,0-1.59-.16-2.22-.49Zm14.22-3.52h-5.86c.02.92.27,1.64.75,2.14.48.5,1.13.75,1.96.75.94,0,1.79-.31,2.58-.92v1.25c-.73.53-1.69.79-2.89.79s-2.09-.38-2.76-1.13c-.67-.76-1.01-1.82-1.01-3.19,0-1.29.36-2.34,1.09-3.15.74-.82,1.65-1.22,2.73-1.22s1.93.35,2.52,1.05c.59.7.89,1.68.89,2.93v.7Zm-1.36-1.13c0-.77-.19-1.36-.56-1.79-.36-.43-.87-.64-1.52-.64s-1.16.22-1.6.67c-.44.45-.71,1.04-.81,1.76h4.48Zm7.22,4.86c-.31.17-.73.26-1.24.26-1.45,0-2.18-.81-2.18-2.43v-4.91h-1.43v-1.14h1.43v-2.03l1.33-.43v2.46h2.09v1.14h-2.09v4.68c0,.56.09.95.28,1.19.19.24.5.36.94.36.34,0,.62-.09.87-.28v1.14Z" />
				<path d="m533.18,877.27h-9.68v-18.27h9.28v1.94h-7.14v6.08h6.6v1.92h-6.6v6.4h7.54v1.94Zm14.09,0h-2.09v-7.44c0-2.77-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.6,1.18-.68.78-1.02,1.77-1.02,2.97v7.44h-2.09v-13.05h2.09v2.17h.05c.99-1.65,2.41-2.47,4.28-2.47,1.43,0,2.52.46,3.27,1.39.76.92,1.13,2.25,1.13,3.99v7.98Zm10.01-.13c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.72h-2.24v-1.78h2.24v-3.19l2.09-.68v3.86h3.29v1.78h-3.29v7.35c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm9.62-10.81c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.65h-2.09v-13.05h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm12.68-2.12l-6,15.14c-1.07,2.7-2.57,4.05-4.51,4.05-.54,0-1-.06-1.36-.17v-1.87c.45.15.86.23,1.24.23,1.05,0,1.84-.63,2.37-1.89l1.04-2.47-5.1-13.02h2.32l3.53,10.04c.04.13.13.46.27.99h.08c.04-.2.13-.53.25-.97l3.71-10.07h2.17Z" />
				<path d="m247.74,225v-18.27h5.2c1.58,0,2.83.39,3.76,1.16.93.77,1.39,1.78,1.39,3.02,0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.24,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.5-2.66h-2.46Zm0,7.82v6.57h2.91c1.26,0,2.23-.3,2.92-.89.7-.59,1.04-1.41,1.04-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm22.99,2.51h-9.21c.03,1.45.42,2.57,1.17,3.36.75.79,1.78,1.19,3.08,1.19,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.92,4.29-1.92s3.03.55,3.96,1.66c.93,1.1,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.14-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.71-1.11,1.63-1.27,2.77h7.05Zm16.41,7.77h-2.09v-2.22h-.05c-.97,1.68-2.46,2.52-4.49,2.52-1.64,0-2.95-.58-3.94-1.75-.98-1.17-1.47-2.77-1.47-4.78,0-2.16.54-3.89,1.63-5.19s2.54-1.95,4.35-1.95,3.1.71,3.91,2.12h.05v-8.08h2.09v19.32Zm-2.09-5.9v-1.92c0-1.05-.35-1.95-1.04-2.68-.7-.73-1.58-1.1-2.65-1.1-1.27,0-2.28.47-3.01,1.4s-1.1,2.23-1.1,3.87c0,1.5.35,2.69,1.04,3.57.71.87,1.65,1.3,2.83,1.3s2.11-.42,2.83-1.26c.73-.84,1.1-1.9,1.1-3.19Zm13.1-5.03c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.65h-2.09v-13.05h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm7.71,11.24c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.8-5.14,1.2-1.23,2.82-1.85,4.85-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.98s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.9c-1.34,0-2.4.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.18,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.87,1.1-2.12,1.1-3.73s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm15.11,11.9c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.8-5.14,1.2-1.23,2.82-1.85,4.85-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.98s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.9c-1.34,0-2.4.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.39,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.87,1.1-2.12,1.1-3.73s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm28.19,11.6h-2.09v-7.49c0-1.44-.23-2.49-.68-3.13-.44-.65-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.82-.93,1.79-.93,2.93v7.44h-2.09v-7.75c0-2.57-.99-3.85-2.97-3.85-.92,0-1.67.39-2.27,1.16-.59.76-.89,1.76-.89,2.99v7.44h-2.09v-13.05h2.09v2.06h.05c.93-1.58,2.28-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.31,1.77,4.31,5.31v8.04Z" />
				<path d="m260.69,244.64c0,1.22-.12,2.3-.36,3.25-.24.95-.59,1.75-1.06,2.41-.46.65-1.03,1.16-1.7,1.5-.67.34-1.43.51-2.28.51s-1.65-.15-2.32-.46v-1.46c.74.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.48-.25.88-.61,1.2-1.08.33-.48.58-1.06.75-1.75.17-.69.26-1.49.26-2.38h-.04c-.57,1.14-1.56,1.71-2.97,1.71-.57,0-1.09-.1-1.57-.3-.48-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.81-1.32-.19-.51-.29-1.07-.29-1.68,0-.65.11-1.25.32-1.8.22-.54.51-1.01.89-1.4.38-.4.83-.7,1.35-.92.53-.22,1.1-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.31,1.18.35.51.62,1.15.81,1.9.19.75.28,1.62.28,2.59Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.08-.23-.3-.52-.53-.84-.7-.32-.17-.67-.25-1.06-.25s-.7.07-1.02.22c-.32.14-.59.35-.82.61-.23.26-.41.57-.55.94-.13.36-.19.75-.19,1.18,0,.47.06.89.19,1.26.13.37.31.69.55.95.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.32-.14.59-.32.82-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="263.14" y="238.79" width="1.34" height="4.14" />
				<path d="m274.76,248.32c0,.6-.11,1.15-.34,1.64-.22.49-.54.91-.95,1.26-.41.35-.9.61-1.47.81-.57.19-1.21.29-1.9.29-1.27,0-2.27-.24-3.02-.72v-1.63c.9.7,1.92,1.06,3.08,1.06.46,0,.88-.06,1.25-.18.38-.12.7-.29.96-.51.27-.22.48-.49.62-.81.15-.32.22-.67.22-1.07,0-1.74-1.24-2.6-3.71-2.6h-1.1v-1.29h1.05c2.19,0,3.28-.82,3.28-2.45,0-1.51-.83-2.26-2.5-2.26-.94,0-1.82.32-2.64.95v-1.47c.85-.51,1.85-.76,3.02-.76.56,0,1.06.08,1.51.23.45.15.84.37,1.16.65.32.28.57.61.74,1,.18.39.27.82.27,1.29,0,1.75-.88,2.87-2.65,3.37v.04c.45.05.87.16,1.25.33.38.17.71.39.99.66s.49.59.65.96c.16.36.24.77.24,1.21Z" />
				<path d="m279.03,238.79v4.14h-1.34v-4.14h1.34Zm3.08,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m297.29,242.59l-3.19,4.8,3.13,4.69h-1.77l-1.86-3.08c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.44.72l-1.9,3.08h-1.75l3.23-4.65-3.1-4.84h1.77l1.84,3.24c.14.24.27.49.4.74h.04l2.37-3.99h1.68Z" />
				<path d="m309.45,252.08h-1.52v-11.48c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.59Zm12.99-6.7c0,1.11-.1,2.1-.31,2.96-.2.86-.49,1.58-.87,2.18-.38.59-.84,1.03-1.4,1.34-.55.3-1.18.45-1.88.45-.67,0-1.26-.15-1.79-.44-.52-.3-.96-.73-1.32-1.29-.36-.56-.63-1.25-.82-2.07-.19-.82-.28-1.76-.28-2.82,0-1.16.1-2.19.29-3.08.2-.89.49-1.63.86-2.23.38-.61.84-1.06,1.4-1.36.56-.31,1.2-.46,1.93-.46,2.79,0,4.18,2.27,4.18,6.81Zm-1.56.15c0-3.78-.9-5.67-2.7-5.67-1.9,0-2.85,1.92-2.85,5.77,0,3.59.93,5.39,2.79,5.39s2.75-1.83,2.75-5.49Z" />
				<rect x="324.74" y="238.79" width="1.34" height="4.14" />
				<path d="m336.36,248.32c0,.6-.11,1.15-.34,1.64-.22.49-.54.91-.95,1.26-.41.35-.9.61-1.47.81-.57.19-1.21.29-1.9.29-1.27,0-2.27-.24-3.02-.72v-1.63c.9.7,1.92,1.06,3.08,1.06.46,0,.88-.06,1.25-.18.38-.12.7-.29.96-.51.27-.22.48-.49.62-.81.15-.32.22-.67.22-1.07,0-1.74-1.24-2.6-3.71-2.6h-1.1v-1.29h1.05c2.19,0,3.28-.82,3.28-2.45,0-1.51-.83-2.26-2.5-2.26-.94,0-1.82.32-2.64.95v-1.47c.85-.51,1.85-.76,3.02-.76.56,0,1.06.08,1.51.23.45.15.84.37,1.16.65.32.28.57.61.74,1,.18.39.27.82.27,1.29,0,1.75-.88,2.87-2.65,3.37v.04c.45.05.87.16,1.25.33.38.17.71.39.99.66s.49.59.65.96c.16.36.24.77.24,1.21Z" />
				<path d="m340.63,238.79v4.14h-1.34v-4.14h1.34Zm3.08,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m310.88,690.04h-2.98l-7.06-8.36c-.26-.31-.42-.53-.48-.64h-.05v9h-2.14v-18.27h2.14v8.59h.05c.12-.19.28-.4.48-.62l6.83-7.96h2.66l-7.84,8.77,8.38,9.51Zm3.19-16.36c-.37,0-.69-.13-.96-.38-.26-.25-.39-.58-.39-.97s.13-.71.39-.97c.26-.26.58-.39.96-.39s.71.13.97.39c.27.25.41.58.41.97s-.14.69-.41.96c-.26.26-.59.39-.97.39Zm1.02,16.36h-2.09v-13.05h2.09v13.05Zm10.26-.13c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.72h-2.24v-1.78h2.24v-3.19l2.09-.68v3.86h3.29v1.78h-3.29v7.35c0,.87.15,1.5.45,1.87s.79.56,1.48.56c.53,0,.98-.14,1.36-.43v1.78Zm11.67-.47c-1,.6-2.19.9-3.57.9-1.86,0-3.36-.6-4.51-1.81-1.14-1.21-1.71-2.79-1.71-4.71,0-2.15.62-3.87,1.85-5.17,1.23-1.31,2.88-1.96,4.93-1.96,1.15,0,2.16.21,3.03.64v2.14c-.97-.68-2-1.02-3.11-1.02-1.33,0-2.43.48-3.29,1.44-.85.95-1.27,2.2-1.27,3.76s.4,2.74,1.2,3.62c.81.88,1.89,1.33,3.24,1.33,1.14,0,2.21-.38,3.21-1.13v1.99Zm13.97.6h-2.09v-7.52c0-2.72-1.01-4.08-3.03-4.08-1.02,0-1.88.39-2.57,1.18-.7.78-1.04,1.79-1.04,3.02v7.39h-2.09v-19.32h2.09v8.44h.05c1-1.65,2.43-2.47,4.28-2.47,2.94,0,4.41,1.77,4.41,5.31v8.04Zm14.41-6h-9.21c.03,1.45.42,2.57,1.17,3.36.75.79,1.78,1.19,3.08,1.19,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.92,4.29-1.92s3.03.55,3.96,1.66c.93,1.1,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.15-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.71-1.11,1.63-1.27,2.77h7.05Zm16.11,7.77h-2.09v-7.44c0-2.77-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.6,1.18-.68.78-1.02,1.77-1.02,2.97v7.44h-2.09v-13.05h2.09v2.17h.05c.99-1.65,2.41-2.47,4.28-2.47,1.43,0,2.52.46,3.27,1.39.76.92,1.13,2.25,1.13,3.99v7.98Z" />
				<path d="m774.62,865.46l-3.05,10.79h-1.48l-2.22-7.89c-.1-.34-.15-.7-.17-1.1h-.03c-.03.37-.1.73-.2,1.08l-2.24,7.9h-1.47l-3.16-10.79h1.39l2.3,8.28c.1.35.16.71.18,1.08h.04c.03-.27.1-.63.23-1.08l2.39-8.28h1.21l2.29,8.34c.08.29.14.62.18,1.01h.03c.02-.26.09-.61.2-1.04l2.21-8.31h1.37Z" />
				<polygon points="780.91 865.46 775.74 878.04 774.58 878.04 779.75 865.46 780.91 865.46" />
				<path d="m782.17,876.25v-10.79h2.98c3.8,0,5.71,1.75,5.71,5.26,0,1.67-.53,3.01-1.59,4.02-1.05,1.01-2.47,1.51-4.24,1.51h-2.86Zm1.26-9.65v8.51h1.61c1.42,0,2.52-.38,3.3-1.14.79-.76,1.18-1.83,1.18-3.22,0-2.76-1.47-4.15-4.41-4.15h-1.69Z" />
			</g>
		</g>
	)
}

export default PlanS
